exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-footer-buttons[data-v-94b1f8c0] {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n.modal-button[data-v-94b1f8c0] {\n    padding: 10px 20px;\n    border: none;\n    cursor: pointer;\n    transition: background-color 0.3s, color 0.3s;\n    border-radius: 5px;\n    background-color: #fff;\n}\n.modal-button[data-v-94b1f8c0]:hover {\n  background-color: #f0f0f0;\n  color: #333;\n}\n.primary-button[data-v-94b1f8c0] {\n    background-color: black;\n    color: #fff;\n}\n.primary-button[data-v-94b1f8c0]:hover {\n    background-color: #cfc2c4;\n}\n.danger-button[data-v-94b1f8c0] {\n    background-color: #dc3545;\n    color: #fff;\n}\n.danger-button[data-v-94b1f8c0]:hover {\n    background-color: #cfc2c4;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-94b1f8c0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Sessionlogout.vue
// module id = 959
// module chunks = 2